import { createContext } from 'react';
import { NavValues } from '../constants/shared/Shared.constants';

const NavFormContext = createContext({
    ...NavValues,
});

export default NavFormContext;
